<template>
	<div class="container-fiuld clearfix">
		<div class="btn-group-box clearfix">
			<div class="btn-group pull-left clearfix">
				<!-- <div class="select pull-left m-r-5">
					<a class="btn round" @click="$emit('onEmail')">
						<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="22" height="20" viewBox="0 0 22 20">
							<path class="msg-i"
								d="M262.519,1266.28a0.158,0.158,0,0,0,.019.08c0,0.02.019,0.06,0.019,0.08a0.473,0.473,0,0,1,.019.08,0.3,0.3,0,0,1,.038.08c0.019,0.02.019,0.04,0.038,0.06a0.107,0.107,0,0,1,.038.06l0.057,0.06,0.019,0.02a0.019,0.019,0,0,1,.019.02,0.447,0.447,0,0,0,.209.12,0.037,0.037,0,0,1,.038.02,0.91,0.91,0,0,0,.228.04h20.5a0.91,0.91,0,0,0,.228-0.04,0.037,0.037,0,0,0,.038-0.02,2.043,2.043,0,0,0,.209-0.12,0.019,0.019,0,0,0,.019-0.02l0.019-.02,0.057-.06a0.107,0.107,0,0,0,.038-0.06c0.019-.02.019-0.04,0.038-0.06a0.3,0.3,0,0,0,.038-0.08,0.1,0.1,0,0,0,.019-0.08c0-.02.019-0.06,0.019-0.08a0.473,0.473,0,0,0,.019-0.08v-18.46a0.792,0.792,0,0,0-.779-0.82H263.279a0.792,0.792,0,0,0-.779.82v18.38A0.1,0.1,0,0,1,262.519,1266.28Zm2.432-.94,5.756-7.25,2.394,1.76a0.752,0.752,0,0,0,.874,0l2.394-1.76,5.756,7.25H264.951Zm18.067-1.44-5.377-6.75,5.358-3.94v10.69h0.019Zm-18.96-15.26H283v2.58l-9.461,6.95-9.48-6.95v-2.58Zm0,4.57,5.357,3.94-5.357,6.75v-10.69Z"
								transform="translate(-262.5 -1247)" />
						</svg> 전자우편 보내기
					</a>
				</div> -->
				<div class="select pull-left m-r-5">
					<a class="btn round" @click="$emit('onSms')">
						<svg xmlns="http://www.w3.org/2000/svg" class="v-mid m-r-5" width="20" height="20" viewBox="0 0 20 20">
							<path class="sms-i"
								d="M386.428,1249.93a10,10,0,0,1,14.807,13.41,3.719,3.719,0,0,0,1.575,1.82,0.933,0.933,0,0,1-.268,1.76,5.3,5.3,0,0,1-.708.05h0a6.478,6.478,0,0,1-3.6-1.16A10,10,0,0,1,386.428,1249.93Zm0.8,13.34a8.909,8.909,0,0,0,10.763,1.38,0.59,0.59,0,0,1,.285-0.08,0.621,0.621,0,0,1,.348.11,5.414,5.414,0,0,0,3.138,1.16,5.789,5.789,0,0,1-1.714-2.37,0.561,0.561,0,0,1,.1-0.6A8.871,8.871,0,1,0,387.229,1263.27Zm2.082-9.57h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1253.7Zm0,2.73h8.38a0.569,0.569,0,0,1,.565.57,0.561,0.561,0,0,1-.565.56h-8.38a0.562,0.562,0,0,1-.566-0.56A0.573,0.573,0,0,1,389.311,1256.43Zm0,2.74h8.38a0.565,0.565,0,1,1,0,1.13h-8.38A0.565,0.565,0,1,1,389.311,1259.17Z"
								transform="translate(-383.5 -1247)" />
						</svg> 문자 보내기
					</a>
				</div>
			</div>

			<div class="btn-group pull-right clearfix">
				<!-- <select class="form-control round pull-left m-r-5">
					<option>10개씩 보기</option>
					<option>30개씩 보기</option>
					<option>50개씩 보기</option>
				</select>
				<select class="form-control round pull-left m-r-5">
					<option>정렬</option>
					<option>신청일 ↑</option>
					<option>신청일 ↓</option>
					<option>강의명순</option>
					<option>교육시작일순</option>
				</select> -->
				<!-- <div class="select pull-left m-r-5">
					<a class="btn round pull-left" href="#">
						<img class="v-mid m-r-5" src="images/x.png" alt=""> 전체 다운로드
					</a>
				</div> -->
			</div>
		</div>

		<table class="table2 table-hover m-t-10 text-center">
			<thead>
				<tr class="bg-lightgray">
					<th>신청일</th>
					<th>강의</th>
					<th>교육기간</th>
					<th colspan="2">강사배정</th>
					<th>신청관리</th>
					<th></th>
				</tr>
			</thead>
			<tbody v-for="(appl,idx) in applList" :key="`list-appl-${hash(appl)}`">
				<tr class="margin">
					<td colspan="7"></td>
				</tr>
				<tr>
					<td>
						{{moment(appl.regDate).format("YYYY-MM-DD")}}
					</td>
					<td class="text-left">
						{{appl.lec.category}}<br>
						{{appl.lec.lecName}}
					</td>
					<td>
						{{applDuration(appl)}}
					</td>
					<td colspan="2">-</td>
					<td>
						<select class="form-control-sm full-width m-b-0 round" @change="changeApplStatus(appl, $event)" :value="appl.applStatus">
							<option value="신청">신청</option>
							<option value="승인">승인</option>
							<option value="취소">취소</option>
							<option value="반려">반려</option>
						</select>
					</td>
					<td>
						<div class="see-more">
							<a @click="toggleSubMenu(idx)">
								<img src="images/see-more.png" width="5" alt="">
							</a>
							<ul :class="{on:subMenuIndex === idx}">
								<li @click="openApplyDetailModal(appl)">신청상세</li>
								<li @click="moveToClassRoom(appl)">강의실</li>
								<li @click="removeAppl(appl)">삭제</li>
							</ul>
						</div>
					</td>
				</tr>
			</tbody>
		</table>

		<ctrl-pagination :currentPage="offset / pageSize + 1"
			:pageSize="pageSize" :totalCount="totalCount"
			:key="hash({pageSize, offset, totalCount})"
			@pageChanged="onPageChanged"></ctrl-pagination>
	</div>
</template>

<script>
import CtrlPagination from '../../components/CtrlPagination.vue'
import Axios from 'axios'
import server from '../../statics/server'

export default {
	name: "SubviewUserDetailApply",
	mounted: async function() {
		await this.getApplyData();
	},
	props: {
		member: Object
	},
	data: function() {
		return {
			applList: [],
			offset: 0,
			pageSize: 10,
			totalCount: 0,
			subMenuIndex: -1,
		}
	},
	components: {
		CtrlPagination,
	},
	// 이 컴포넌트에서 구현되어야 할 기능
	methods: {
		getApplyData: async function () {
			if(!this.member) return;

			try {
				const { offset, pageSize } = this;
				const { data } = await Axios.post(`${server.addr()}${server.api.APPL}`, {
					mberId: this.member.mberId, offset, pageSize
				});

				this.applList = data.list;
				this.totalCount = parseInt(data.filtered);
			} catch(e) {
				// TODO: error excectpion
			}
		},
		applDuration: function(appl) {
			if(Array.isArray(appl.applEduDateList) && appl.applEduDateList.length && appl.applEduDateList[0].eduStartDate) {
				return appl.applEduDateList[0].eduStartDate + " ~ " + appl.applEduDateList[0].eduEndDate;
			}
			else if(Array.isArray(appl.applEduDateList) && appl.applEduDateList.length > 1 && appl.applEduDateList[0].eduStartDate) {
				return appl.applEduDateList[0].eduStartDate + " ~ " + appl.applEduDateList[appl.applEduDateList.length.length-1].eduStartDate;
			}
			else {
				return "승인되지 않았으므로 수강기간을 산정할 수 없음";
			}
		},
		changeApplStatus: async function(appl, $event) {
			const { value } = $event.target;
			try {
				await Axios.patch(`${server.addr()}${server.api.APPL}/${appl.applId}`, {
					applStatus: value
				});
			} catch(e) {
				// eslint-disable-next-line
				console.warn(e);
				// TODO: error exception
			}
		},
		moveToClassRoom: function(appl) {
			window.open( "#/classroom/"+appl.lec.lecId+"/curriculum", "classroom", "" );
		},
		removeAppl: async function(appl) {
			this.$emit("onConfirm", {
				message: "정말로 삭제하시겠습니까?",
				yesCb: async () => {
					try {
						await Axios.delete(`${server.addr()}${server.api.APPL}/${appl.applId}`);
					} catch(e) {
						// eslint-disable-next-line
						console.warn(e);
						// TODO: error exception
					}
				}
			});
		},
		// 페이지네이션 이벤트 핸들러
		onPageChanged: function(page) {
			const { pageSize } = this;
			this.offset = (page - 1) * pageSize;
			this.getApplyData();
		},
		openApplyDetailModal: function(appl) {
			this.$emit("openApplyDetailModal", appl)
		},
		toggleSubMenu: function(index) {
			if(index === this.subMenuIndex) { this.subMenuIndex = -1; }
			else this.subMenuIndex = index;
		},
	},
	watch: {
		member: function(val) {
			val;
			this.getApplyData();
		}
	}
}
</script>

<style scoped>
.see-more ul:hover {
	display: block;
}
.msg-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .msg-i {
	fill: #fff;
	fill-rule: evenodd;
}
.sms-i {
	fill: #999;
	fill-rule: evenodd;
}
.btn-group .btn:hover .sms-i {
	fill: #fff;
	fill-rule: evenodd;
}
</style>